<template>
  <DataTable :value="products" class="primevue-dtable tablepaginator p-datatable-customers rwd-table my-4">
    <Column v-for="col in columns" :key="col.field" :header="col.header" :style="{ width: col.width || '150px' }">
      <template #body>
        <Skeleton :width="col.width || '150px'" height="24px"></Skeleton>
      </template>
    </Column>
  </DataTable>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Skeleton from 'primevue/skeleton';

interface Column {
  field: string;
  header: string;
  width?: string;
  [key: string]: any;
}

interface Props {
  columns: Column[];
  loading?: boolean;
}

defineProps<Props>();

// Create an array of 10 empty items for skeleton rows
const products = ref(Array(10).fill(null));
</script>
